const COMPACT_HOTEL_CARD_BACKGROUND = '#E8E9ED';
const DESKTOP_HOTEL_CARD_BACKGROUND = 'var(--Neutrals-Base-white, #FBFBFB)';
const DESKTOP_HOTEL_CARD_RADIUS = '32px';

/**
 * Shell color and radius for the homepage hotel search card.
 * MUI Paper injects background and border-radius after HotelForm.css in a
 * production build, so the compact grey shell has to be set here.
 */
export function getHotelSearchCardChrome({ isEmbedded, isCompact, radius }) {
  if (isEmbedded) {
    return { borderRadius: 0, background: 'transparent' };
  }
  if (isCompact) {
    return {
      borderRadius: radius,
      background: COMPACT_HOTEL_CARD_BACKGROUND,
    };
  }
  return {
    borderRadius: { xs: radius, md: DESKTOP_HOTEL_CARD_RADIUS },
    background: { xs: COMPACT_HOTEL_CARD_BACKGROUND, md: DESKTOP_HOTEL_CARD_BACKGROUND },
  };
}
